
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Date} from '../core/Date';
import {FieldModelDate} from '../core/Date';

/**
 * BillingStatisticsGetParams struct
 */
class BillingStatisticsGetParams {
  /**
   * Initialize struct
   * @param {!Date=} from
   * @param {!Date=} to
   * @constructor
   */
  constructor (from = new Date(), to = new Date()) {
    this.From = from
    this.To = to
  }

  /**
   * Copy struct (shallow copy)
   * @this {!BillingStatisticsGetParams}
   * @param {!BillingStatisticsGetParams} other Other struct
   * @returns {!BillingStatisticsGetParams} This struct
   */
  copy (other) {
    if (other.From != null) {
      this.From = Date.fromObject(other.From)
    } else {
      this.From = null
    }
    if (other.To != null) {
      this.To = Date.fromObject(other.To)
    } else {
      this.To = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!BillingStatisticsGetParams}
   * @returns {!BillingStatisticsGetParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new BillingStatisticsGetParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new BillingStatisticsGetParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!BillingStatisticsGetParams}
   * @param {!BillingStatisticsGetParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof BillingStatisticsGetParams)) {
      throw new TypeError('Instance of BillingStatisticsGetParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!BillingStatisticsGetParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      From: ((this.From != null) ? this.From : null),
      To: ((this.To != null) ? this.To : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return BillingStatisticsGetParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!BillingStatisticsGetParams} other Object value
   * @returns {!BillingStatisticsGetParams} Created struct
   */
  static fromObject (other) {
    return new BillingStatisticsGetParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!BillingStatisticsGetParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return BillingStatisticsGetParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!BillingStatisticsGetParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 10048
  }
}

export { BillingStatisticsGetParams };

/**
 * Fast Binary Encoding BillingStatisticsGetParams field model
 */
class FieldModelBillingStatisticsGetParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.From = new FieldModelDate(buffer, 4 + 4)
    this.To = new FieldModelDate(buffer, this.From.fbeOffset + this.From.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelBillingStatisticsGetParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelBillingStatisticsGetParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.From.fbeSize + this.To.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelBillingStatisticsGetParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.From.fbeExtra + this.To.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelBillingStatisticsGetParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelBillingStatisticsGetParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelBillingStatisticsGetParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 10048
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelBillingStatisticsGetParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelBillingStatisticsGetParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.From.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.From.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.From.fbeSize

    if ((fbeCurrentSize + this.To.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.To.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.To.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelBillingStatisticsGetParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelBillingStatisticsGetParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelBillingStatisticsGetParams}
   * @param {!BillingStatisticsGetParams} fbeValue Default value, defaults is new BillingStatisticsGetParams()
   * @returns {!BillingStatisticsGetParams} BillingStatisticsGetParams value
   */
  get (fbeValue = new BillingStatisticsGetParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelBillingStatisticsGetParams}
   * @param {!BillingStatisticsGetParams} fbeValue BillingStatisticsGetParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.From.fbeSize) <= fbeStructSize) {
      fbeValue.From = this.From.get()
    } else {
      fbeValue.From = new Date()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.From.fbeSize

    if ((fbeCurrentSize + this.To.fbeSize) <= fbeStructSize) {
      fbeValue.To = this.To.get()
    } else {
      fbeValue.To = new Date()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.To.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelBillingStatisticsGetParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelBillingStatisticsGetParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelBillingStatisticsGetParams}
   * @param {!BillingStatisticsGetParams} fbeValue BillingStatisticsGetParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelBillingStatisticsGetParams}
   * @param {BillingStatisticsGetParams} fbeValue BillingStatisticsGetParams value
   */
  setFields (fbeValue) {
    this.From.set(fbeValue.From)
    this.To.set(fbeValue.To)
  }
}

export { FieldModelBillingStatisticsGetParams };

/**
 * Fast Binary Encoding BillingStatisticsGetParams model
 */
class BillingStatisticsGetParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelBillingStatisticsGetParams(this.buffer, 4)
  }

  /**
   * Get the BillingStatisticsGetParams model
   * @this {!BillingStatisticsGetParamsModel}
   * @returns {!FieldModelBillingStatisticsGetParams} model BillingStatisticsGetParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!BillingStatisticsGetParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!BillingStatisticsGetParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return BillingStatisticsGetParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!BillingStatisticsGetParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelBillingStatisticsGetParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!BillingStatisticsGetParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!BillingStatisticsGetParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!BillingStatisticsGetParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!BillingStatisticsGetParamsModel}
   * @param {!BillingStatisticsGetParams} value BillingStatisticsGetParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!BillingStatisticsGetParamsModel}
   * @param {!BillingStatisticsGetParams} value BillingStatisticsGetParams value, defaults is new BillingStatisticsGetParams()
   * @return {!object} Deserialized BillingStatisticsGetParams value and its size
   */
  deserialize (value = new BillingStatisticsGetParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new BillingStatisticsGetParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new BillingStatisticsGetParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!BillingStatisticsGetParamsModel}
   * @param {!number} prev Previous BillingStatisticsGetParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { BillingStatisticsGetParamsModel };
